import { connect } from "react-redux";

import Share from "./Share";

export default connect(state => ({
	share: state.settings.share,
	auth: state.user
}))(Share);
